import { render, staticRenderFns } from "./leaveMsgForSaleMen.vue?vue&type=template&id=7cc53ed5&scoped=true"
import script from "./leaveMsgForSaleMen.vue?vue&type=script&lang=js"
export * from "./leaveMsgForSaleMen.vue?vue&type=script&lang=js"
import style0 from "./leaveMsgForSaleMen.vue?vue&type=style&index=0&id=7cc53ed5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc53ed5",
  null
  
)

export default component.exports